import { Box } from "@mui/material"

type Translation = { language: string; text: string }

const LANGUAGES: { code: string; flag: string }[] = [
  { code: "en", flag: "🇬🇧" },
  { code: "de", flag: "🇩🇪" }
]

/** Renders translations as one line per language (English, German), each prefixed with a flag. */
export default function TranslationsCell({ translations }: { translations: Translation[] }) {
  return (
    <>
      {LANGUAGES.map(({ code, flag }) => {
        const text = translations.find((t) => t.language === code)?.text
        return (
          <Box key={code} sx={{ display: "flex", gap: 0.75 }}>
            <span aria-hidden>{flag}</span>
            <span>{text || "—"}</span>
          </Box>
        )
      })}
    </>
  )
}
